import BreadcrumbTwo from "../../../components/Breadcrumbs/BreadcrumbTwo";
import ProductUnitTable from "../../../components/Catalog/units/ProductUnitTable";
import DefaultLayout from "../../../layout/DefaultLayout";

const ItemUnits = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ProductUnitTable/>
    </DefaultLayout>
  );
};

export default ItemUnits;
